<script>
    import { onMount } from "svelte";
    import * as Common from "../utiles/common.util";
    import * as api from "../stores/auth.store";
    import { push } from "svelte-spa-router";

    let as_login_id_value = "";
    let as_login_id_this;

    let as_password_value = "";
    let as_password_this;

    onMount(() => {
        if (!window.location.href.includes("/login")) {
            push("/login");
        } else {
            // 로그인 상태 체크
            api.apiGetStatus();
        }
    });

    async function login() {
        if (Common.nullCheck(as_login_id_value, "as_login_id", "아이디"))
            return;
        if (Common.nullCheck(as_password_value, "as_password", "비밀번호"))
            return;

        await api.apiPostlogin(as_login_id_value, as_password_value);
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="logo-wrap">
    <div class="login-wrap">
        <div class="logo-in">
            <!-- <img src="resource/img/logo.png" alt="" class="logo" /> -->
        </div>
        <div class="login-info">
            <p class="info-title">LOGIN</p>
            <div class="login-info-in">
                <p>ID</p>
                <input
                    bind:value={as_login_id_value}
                    bind:this={as_login_id_this}
                    on:keydown={(e) => {
                        e.key === "Enter" ? login() : "";
                    }}
                    id="as_login_id"
                    type="text"
                />
            </div>
            <div class="login-info-in">
                <p>PW</p>
                <input
                    bind:value={as_password_value}
                    bind:this={as_password_this}
                    on:keydown={(e) => {
                        e.key === "Enter" ? login() : "";
                    }}
                    id="as_password"
                    type="password"
                />
            </div>
        </div>
        <div class="btn" on:click={login}>
            <p>LOGIN</p>
        </div>
    </div>
</div>
